import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useFetalDeathChartsDataContext } from './hooks/useFetalDeathChartsDataContext';

export const TypesOfPregnancy = () => {
    const { chartData } = useFetalDeathChartsDataContext();


    return (
        <SimpleBars
            title={'Tipo de gravidez'}
            horizontal={false}
            subtitles={chartData?.typesOfPregnancy?.map((item) => item.description)}
            values={chartData?.typesOfPregnancy?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
